import { Component, OnInit } from '@angular/core';
import moment from 'moment';
import { catchError, throwError } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { tap } from 'rxjs/internal/operators/tap';
import { KpisDashboardIncadea } from 'src/services/api-services/api-interfaces/api-interface-incadea-dashboard';
import { DashboardIncadeaService } from 'src/services/api-services/dashboardIncadeaBooking.service';
import { HelperService } from 'src/services/helperService';

@Component({
    selector: 'app-i-dashboard',
    templateUrl: './i-dashboard.component.html',
    styleUrls: ['./i-dashboard.component.sass'],
    standalone: false
})
export class IDashboardComponent implements OnInit {

  calendarGrid: string = 'col-lg-6'
  chartGrid: string = 'col-lg-6'
  chartGrid2: string = 'col-lg-12'
  selectedMonth: number = 0;
  isChartExpanded: boolean = false

  isLoading:boolean = false
  Datereal = new Date();
  dataKPI$: Observable<KpisDashboardIncadea[]> = new Observable<KpisDashboardIncadea[]>()
  years: string[] = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];



  constructor(
    public dashboardIncadeaService: DashboardIncadeaService,
    public helperService: HelperService,
  ) { }

    //Responsive interface design controls
  expandCollapseChart(toExpand: boolean): void {

    let currentDate = moment();
    this.isChartExpanded = toExpand;
    this.calendarGrid = toExpand ? 'col-lg-1' : 'col-lg-6';
    this.chartGrid = toExpand ? 'col-lg-11' : 'col-lg-6';
    this.chartGrid2 = toExpand ? 'col-lg-12': 'col-lg-12';
    //Sets the selected month
    this.selectedMonth = currentDate.month() + 1;

    window.setTimeout(function () {
      window.dispatchEvent(new Event('resize'));
    }, 300);

  }

  ngOnInit(): void {
   this.evaluateProfileMetricCards()
  }

  //Creates Date objects for two months and calculates the difference in days between their last days
  getLastDayOfMonth(year, month) {
    let currentMounth:any = new Date(year, month);
    let nextMounth:any = new Date(year, month + 1);
    let result = (nextMounth - currentMounth)/86400000;
    return result;
  }

  //brings the KPIS information depending on the profile
  evaluateProfileMetricCards(){

    switch (this.helperService.user.role.roleId) {

      case 3: //Contact Center Advisor
      this.dataKPI$ = this.dashboardIncadeaService?.getIBKPIs(this.helperService.user.role.roleId, this.helperService.user.countryId, moment(new Date()).format("YYYY-MM-DD"), moment(new Date()).format("YYYY-MM-DD"))

     break

      case 4: //Super Retail Group Administrator

      this.dataKPI$ = this.dashboardIncadeaService?.getIBKPIs(this.helperService.user.role.roleId, this.helperService.user.countryId, this.Datereal.getFullYear()+"-"+
        (this.Datereal.getMonth()+1)+"-"+ 1,this.Datereal.getFullYear()+"-"+ (this.Datereal.getMonth()+1)+"-"+
        this.getLastDayOfMonth(this.Datereal.getFullYear(), this.Datereal.getMonth() ),this.helperService.user.incadeaCompanyId)
        .pipe(
          tap((response) => {
          //  console.log(response)
           this.isLoading = false;
          }),
          catchError((error) => {
            // Manejo de error 401
            if (error.status === 401) {
              this.helperService.logoutToken();
            }

            return throwError(() => error);
          }
          )
        )

      break

    }
  }

}
